import { onMounted, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const TEAM_CHAT_POLL_MS = 30000;

// Boot dos dados da conta: inboxes, etiquetas, times, atributos, pastas,
// funis, apps e contadores.
//
// HISTORIA OBRIGATORIA para quem pensar em mover isto de lugar: esses
// dispatches moravam no onMounted do Sidebar.vue antigo. O PR #483 (6 mundos)
// apagou o componente e NINGUEM herdou o boot — a sessao inteira rodava com
// zero inboxes no store. Efeito visivel: os botoes de anexo/audio/video da
// caixa de resposta somem (todos dependem de inbox.channel_type), pastas e
// etiquetas vazias, contadores mortos. Foi para producao na v839 e o Lucas
// pegou no uso real.
//
// Por isso virou composable proprio, chamado pelo SHELL do dashboard
// (Dashboard.vue), que monta uma vez por sessao e nao e sujeito a redesign
// de navegacao. Dado de conta nao pertence a um componente de UI.
export function useAccountBootstrapData() {
  const store = useStore();
  const { accountId } = useAccount();

  const hasConversationUnreadCounts = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  let teamChatPollInterval = null;

  const fetchAll = () => {
    store.dispatch('labels/get');
    store.dispatch('inboxes/get');
    store.dispatch('notifications/unReadCount');
    store.dispatch('teams/get');
    store.dispatch('attributes/get');
    store.dispatch('customViews/get', 'conversation');
    store.dispatch('customViews/get', 'contact');
    store.dispatch('dashboardApps/get');
    store.dispatch('integrations/get');
    store.dispatch('funnel/fetch');
    store.dispatch('kanban/fetchKanbanConfig');
    store.dispatch('teamChat/fetchUnreadCount');
  };

  const syncConversationUnreadCounts = () => {
    if (!accountId.value) return;
    const enabled = hasConversationUnreadCounts.value?.(
      accountId.value,
      FEATURE_FLAGS.CONVERSATION_UNREAD_COUNTS
    );
    if (!enabled) {
      store.dispatch('conversationUnreadCounts/clear');
      return;
    }
    store.dispatch('conversationUnreadCounts/get');
  };

  onMounted(() => {
    fetchAll();
    teamChatPollInterval = setInterval(() => {
      store.dispatch('teamChat/fetchUnreadCount');
    }, TEAM_CHAT_POLL_MS);
  });

  onBeforeUnmount(() => {
    if (teamChatPollInterval) {
      clearInterval(teamChatPollInterval);
      teamChatPollInterval = null;
    }
  });

  // Troca de conta recarrega tudo — o shell nao remonta ao navegar entre
  // contas, so a rota muda.
  watch(accountId, (novo, antigo) => {
    if (novo && antigo && novo !== antigo) fetchAll();
    syncConversationUnreadCounts();
  });

  onMounted(syncConversationUnreadCounts);
}
